import { useEffect } from "react";
import Login from "../components/Others/Login/Login";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const LoginScreen = () => {
  const navigate = useNavigate();
  const userState = useSelector((state) => state.userState);
  const { userInfo } = userState;

  useEffect(() => {
    if (userInfo) {
      navigate(
        userInfo?.role === "ROLE_ADMIN"
          ? "/admin"
          : userInfo?.role === "ROLE_SUPER_ADMIN"
          ? "/dashboard"
          : "/"
      );
    }
  }, [userInfo]);

  return <Login />;
};

export default LoginScreen;
